import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/helsinkiofficial/stories")({
  head: () => ({
    meta: [
      { title: "Helsinkiofficial Stories — what Finland" },
      {
        name: "description",
        content:
          "Featured Helsinkiofficial Instagram stories curated by what Finland — daily moments from Helsinki's official channel.",
      },
      { property: "og:title", content: "Helsinkiofficial Stories — what Finland" },
      {
        property: "og:description",
        content: "Featured Helsinkiofficial Instagram stories curated by what Finland.",
      },
    ],
  }),
  component: HelsinkiofficialStoriesPage,
});

function HelsinkiofficialStoriesPage() {
  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <header className="mb-10">
          <p className="text-sm uppercase tracking-wider text-neutral-500">Helsinkiofficial</p>
          <h1 className="text-4xl sm:text-5xl font-semibold mt-2">Stories</h1>
          <p className="mt-4 text-lg text-neutral-700 max-w-2xl">
            Daily Instagram stories from{" "}
            <a
              href="https://instagram.com/helsinkiofficial"
              target="_blank"
              rel="noreferrer noopener"
              className="underline underline-offset-4"
            >
              @helsinkiofficial
            </a>
            . Highlighted stories from features published with what Finland appear below.
          </p>
        </header>
        <section className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              className="aspect-[9/16] rounded-2xl bg-gradient-to-b from-neutral-100 to-neutral-200 border border-neutral-200 flex items-end p-3 text-xs text-neutral-500"
            >
              Coming soon
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
